/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MiscellaneousSpec { 
    /**
     * Mask Operator Email
     */
    mask_operator_email?: boolean;
    /**
     * Enable/ Disable Audit Logging
     */
    audit_enabled?: boolean;
}

